export default __webpack_public_path__ + "static/media/map.537152e7.png";